import type { ContentLocale } from '@/data/public-catalog'

export const pointOfCareProducts = {
  'prd-accre8-immunometria': {
    key: 'accre8',
    primaryMedia: '/media/source/images/ACCRE8-2.png',
    sourceLocale: 'it',
  },
  'prd-cpa-easynat-real-time-molecular-diagnostic-system-vet': {
    key: 'easyNat',
    primaryMedia: '/media/source/images/Easynat.png',
    sourceLocale: null,
    supportingMedia: [
      '/media/source/images/Easynat-kit.png',
      '/media/source/images/CPA-workflow-1-scaled.png',
      '/media/source/images/test-CPA.png',
    ],
  },
  'prd-poch100i-sysmex': {
    key: 'poch100i',
    primaryMedia: '/media/source/images/POCH-100-1.png',
    sourceLocale: 'it',
  },
  'prd-analizzatore-biochimico-a-secco-automatico-sd1': {
    key: 'sd1',
    primaryMedia: '/media/source/images/SD1-1.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/Tabella-SD1.png'],
  },
  'prd-sg1': {
    key: 'sg1',
    primaryMedia: '/media/source/images/SG1-2.png',
    sourceLocale: 'it',
    supportingMedia: ['/media/source/images/BG10N.png'],
  },
} as const

export type PointOfCareProductId = keyof typeof pointOfCareProducts
export type PointOfCareProductKey = (typeof pointOfCareProducts)[PointOfCareProductId]['key']

export function isPointOfCareProductId(id: string): id is PointOfCareProductId {
  return id in pointOfCareProducts
}

export function pointOfCareSourceLocale(id: PointOfCareProductId, language: ContentLocale): ContentLocale {
  return pointOfCareProducts[id].sourceLocale ?? language
}
